module.exports = __webpack_public_path__ + "img/loginbg.f3a31f28.png";